import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-calender-report-details',
  templateUrl: './calender-report-details.component.html',
  styleUrls: ['./calender-report-details.component.scss']
})
export class CalenderReportDetailsComponent implements OnInit {
  @Input() modelPopUp;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  constructor(public activeModel:NgbActiveModal,translate: TranslateService) { }

  ngOnInit(): void {
  }
  close()
  {
    this.activeModel.close(this.modelPopUp);

  }
  UpdateFilling(reportUrl) {   
      window.open(reportUrl, "_blank");      
  }
  getShortName(fullName) { 
    return fullName.substring(0, 1);
  }

  
}
